import { render, staticRenderFns } from "./justificationTypeModal.vue?vue&type=template&id=510272e5&"
import script from "./justificationTypeModal.vue?vue&type=script&lang=js&"
export * from "./justificationTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports